angular.module('gym.mobile_app', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.mobile_app', {
    url: '/mobile_app',
    abstract: true,
    template: '<ui-view>'
  }).state('gym.mobile_app.optIn', {
    url: '/settings/toggle',
    controller: 'MobileAppOptInCtrl',
    template: require('templates/gyms/mobile_app/toggle.html.slim'),
    resolve: {
      planData: ["$stateParams", "$http", function($stateParams, $http) {
        var url;
        url = `/subscription_plans?gymId=${$stateParams.gymId}`;
        return $http.get(url).then(function(response) {
          return response.data.plan_data;
        });
      }]
    }
  }).state('gym.mobile_app.settings', {
    url: '/settings?tab',
    controller: 'MobileAppSettingsCtrl',
    template: require('templates/gyms/mobile_app/settings.html.slim'),
    reloadOnSearch: false
  });
}]);
